import { render, staticRenderFns } from "./leisuremanual.vue?vue&type=template&id=5974117f"
import script from "./leisuremanual.vue?vue&type=script&lang=ts"
export * from "./leisuremanual.vue?vue&type=script&lang=ts"
import style0 from "./leisuremanual.vue?vue&type=style&index=0&id=5974117f&prod&lang=scss"
import style1 from "./leisuremanual.vue?vue&type=style&index=1&id=5974117f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports